import { generateRandomString } from "utils/random";
import { generateLoginUrl, logout } from "utils/oauth";
import { storage as localStorage, OAUTH_STATE, OAUTH_TOKEN } from "utils/local-storage";
import { UNKNOWN_ERROR } from "actions/app-actions";
import { browserHistory } from "react-router";

export const SET_OAUTH_STATE = "actions/oauth/set-oauth-state";
export const SET_OAUTH_TOKEN = "actions/oauth/set-oauth-token";

export const logoutAction = () => {
  localStorage.remove(OAUTH_STATE);
  localStorage.remove(OAUTH_TOKEN);
  logout();
  return {
    type: "NOOP"
  };
};

export const setOauthStateAction = (newState) => ({
  type: SET_OAUTH_STATE,
  data: newState
});

export const setOauthTokenAction = (newToken) => ({
  type: SET_OAUTH_TOKEN,
  data: newToken
});


export const redirectToLoginAction = () => {
  const oauthState = generateRandomString();
  localStorage.set(OAUTH_STATE, oauthState);
  return (dispatch) => {
    dispatch(setOauthStateAction(oauthState));
    document.location.href = generateLoginUrl(oauthState);
  };
};

export const newOauthTokenAction = ({ token, state }) => {
  const currentOauthState = localStorage.get(OAUTH_STATE);
  return (dispatch) => {
    if (currentOauthState !== state) {
      dispatch({
        type: UNKNOWN_ERROR,
        data: { message: "An error occurred while signing in" }
      });
    } else {
      localStorage.set(OAUTH_TOKEN, token);
      dispatch({
        type: SET_OAUTH_TOKEN,
        data: token
      });
    }
    browserHistory.push("/");
  };
};




// WEBPACK FOOTER //
// ./src/js/actions/oauth-actions.js